export const formatSearchTerm = (text: string) => {
  // Postcode has a combination of uppercase and number
  const isPostcode = (text?.match(/[A-Z][0-9]/)?.length || 0) > 0 ? true : false;
  const formattedSearchTerm = !isPostcode
    ? text
        ?.replaceAll("-", " ")
        .toLowerCase()
        .replace(/\b\w/g, (char) => char.toUpperCase())
    : text;
  return formattedSearchTerm;
};

export const toTitleCase = (str: string) => {
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};
